import { useMemo } from 'react';
import { LegalPageLayout } from '../components/legal-page-layout';
import { MarkdownRenderer } from '@/components/ui/markdown-renderer';
import { privacyContent } from '../data/privacy-content';
import { extractHeadings } from '../utils/extract-headings';

export function PrivacyPage() {
  const headings = useMemo(() => extractHeadings(privacyContent), []);

  return (
    <LegalPageLayout title="Politica de Privacidad" lastUpdated="Marzo 2026" headings={headings}>
      <MarkdownRenderer content={privacyContent} />
    </LegalPageLayout>
  );
}
